import { FlaskConical } from "lucide-react";

/** Test-mode payments only take Stripe's test card — a real card is always declined. */
export const SandboxNotice = ({ testId = "sandbox-notice" }) => (
  <div data-testid={testId} className="rounded-lg border border-amber-500/40 bg-amber-500/10 p-4">
    <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-amber-300">
      <FlaskConical className="h-3.5 w-3.5" /> Test mode · no real money moves
    </p>
    <p className="mt-2 text-xs leading-relaxed text-amber-100/90">
      This Stripe account is in test mode, so only its test card works — a real card will be
      declined. Use{" "}
      <span data-testid={`${testId}-card`} className="font-mono text-amber-200">4242 4242 4242 4242</span>{" "}
      with any future expiry · any CVC · any ZIP.
    </p>
  </div>
);
